import React from "react"
import { UserDropdown } from "./UserDropdown"
import { css } from "@emotion/react"
import { SelectorText } from "../../selector-text/SelectorText"
import { useTranslation } from "react-i18next"
import { useAuthModals } from "../../../context/AuthModalsContext"
import { translationKeys } from "../../../util/translationKeys"
import { useAccount } from "../../../context/AccountContext"

type Props = {
  countryCode?: string
  additionalCss?: any
}

const guestInfoWrapper = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`

export const AuthWrapper = ({ additionalCss }: Props) => {
  const { t } = useTranslation()

  const { setVisibleAuthModal } = useAuthModals()
  const { accountType } = useAccount()

  return (
    <div css={additionalCss}>
      {accountType === "user" && <UserDropdown />}
      {accountType === "guest" && (
        <div css={guestInfoWrapper}>
          <SelectorText onClick={() => setVisibleAuthModal("login")}>
            {t(translationKeys.comboWelcomeLogind)}
          </SelectorText>
          <SelectorText
            bold={true}
            onClick={() => setVisibleAuthModal("register")}
          >
            {t(translationKeys.startCreateProfile)}
          </SelectorText>
        </div>
      )}
    </div>
  )
}
